/* GeneratedContentHash: 21c907313efd937fd392c0ef081cd7fc291031bc9e7af37de71b08104d98f266 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'recommendation-jpd': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--recommendation-jpd/placements/in-app/confluence-home-banner/render'
			),
	),
	'recommendation-jsm': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--recommendation-jsm/placements/in-app/confluence-home-banner/render'
			),
	),
	'recommendation-jsw-real-time-updates': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--recommendation-jsw-real-time-updates/placements/in-app/confluence-home-banner/render'
			),
	),
	'recommendation-jsw-visualize-work': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--recommendation-jsw-visualize-work/placements/in-app/confluence-home-banner/render'
			),
	),
};
